import styled from '../theme/styled.js';
import { token } from '../theme/tokens.js';
import { formatMoney } from '../utils/utils.js';

const Wrapper = styled.span(({ theme, isBold }) => ({
    fontFamily: isBold ? token(theme, 'font.bold') : token(theme, 'font.body'),
}));

const InlineCurrencySup = styled.sup({
    padding: '0 1px',
    position: 'relative',
    top: '0.1875em',
    fontSize: '0.6em',
});

const CurrencyCode = styled.span(({ theme }) => ({
    fontWeight: 'normal',
    fontFamily: token(theme, 'font.body'),
}));

// TODO: unthread the placeholder for invalid pricing and make a singular Money component
const Money = ({ hasValidPricing, currencySymbol, currencyCode, showCurrencyCode = false, value, styles }) => {
    if (!hasValidPricing) {
        return '-';
    }

    if (typeof value === 'number') {
        return <Wrapper isBold={styles?.isBold}>
            {/**
             * The displayed figure is assembled from several pieces — a superscript currency
             * symbol, a rounded amount, an optional currency code — so the text a machine
             * would scrape reads as "$71.99 USD" with the decimal buried in markup. Wrapping
             * it in `<data value>` publishes the raw number alongside the presentation, which
             * is what `<data>` exists for.
             *
             * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/data
             */}
            <data value={value}>
                {value < 0 && <>-</>}
                {currencySymbol && <InlineCurrencySup>{currencySymbol}</InlineCurrencySup>}
                {formatMoney(Math.abs(value))}
                {showCurrencyCode && currencyCode && <CurrencyCode>&nbsp;{currencyCode.toUpperCase()}</CurrencyCode>}
            </data>
        </Wrapper>
        ;
    }

    return value;
};

export {
    Money,
};
